import { Platform, StyleSheet, Text, View } from 'react-native'
import { colors, fontFamily, fontWeight, radius, space } from '../tokens'

const Spark = () =>
  Platform.OS === 'web' ? (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      width={15}
      height={15}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ color: colors.primary[700] }}
    >
      <path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M18 6l-2.5 2.5M8.5 15.5L6 18" />
    </svg>
  ) : null

export const FulfilmentHeader = () => (
  <View style={styles.row}>
    <View style={styles.left}>
      <Text style={styles.h1}>Send your appeal to the Valuation Office (part of HMRC)</Text>
      <Text style={styles.sub}>Three quick steps — we've done the hard part for you.</Text>
    </View>
    <View style={styles.pill}>
      <Spark />
      <Text style={styles.pillText}>Informal review · ~41% success vs ~19% formal</Text>
    </View>
  </View>
)

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: space[16],
    marginTop: 30,
    marginBottom: 18,
    paddingHorizontal: 2,
  },
  left: { flexShrink: 1, minWidth: 240 },
  h1: {
    fontSize: 30,
    fontWeight: fontWeight.medium,
    fontFamily: fontFamily.serif,
    color: colors.ink,
    letterSpacing: -0.65,
  },
  sub: { marginTop: 5, fontSize: 15, color: colors.muted },
  pill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    backgroundColor: colors.primary[100],
    paddingVertical: 8,
    paddingHorizontal: 13,
    borderRadius: radius.pill,
  },
  pillText: { fontSize: 12.5, fontWeight: fontWeight.semibold, color: colors.primary[700] },
})
